export default "__VITE_ASSET__DNO1wQnV__"